import { InjectionToken } from '@angular/core';

export interface EnvironmentConfig {
  production: boolean;
  pureSpectrum: {
    url: string;
    activityUrl: string;
    decipherUrl: string;
    ipsosUrl: string;
    nightcrawlerUrl: string;
    buyerExternalIntegrationUrl: string;
    reconcilationUrl: string;
    feasibilityUrl: string;
    priceRecommendUrl: string;
    rmfUrl: string;
    legacyPlatformUrl: string;
    surveyStatiscticsServiceUrl: string;
    reportServiceUrl: string;
    qaToolsUrl: string;
  };
  BUCKET_URL: string;
  churnzeroUrl: string;
  CATPTCHA_SITE_KEY: string;
  QUICKBOOK_VAT_REALMS: number[];
  BUYER_TEST_LINK_SUPPLIER_ID: number;
  PS_CMP_ID: number;
  ENABLE_HOTJAR_EVENT: boolean;
  FUSION_CMP_ID: number;
  FUSION_API_URL: string;
  ZAPPI_STORE_BUYER_IDS: number[];
  PUREPRICE_RATECARD_NOTIFICATION_SLACK_CHANNEL: string;
  appcuesUrl: string;
  ENV: string;
}

export const ENV_CONFIG = new InjectionToken<EnvironmentConfig>(
  'environment.config',
);
